import { columnHelper } from './helper';

export const title = columnHelper.accessor('title', {
  header: '标题',
  id: 'title',
});
